import { LocalStorageService } from './../../core/services/local-storage/local-storage.service';
import { Component, ElementRef, Input, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { CommonServiceService } from 'src/app/core/services/common-service/common-service.service';
//import { MessageService } from './../../../app/core/web-socket/message.service';
@Component({
    selector: 'app-article-long-story',
    templateUrl: './article-long-story.component.html',
    styleUrls: ['./article-long-story.component.scss'],
})
export class ArticleLongStoryComponent {
    @Input() longStoryData: any;
    @Input() paraClickId: any;
    loading: boolean = true;
    showDashboardHome = true;

    elem: any;

    private articleLongStoryDataActual: Subscription;
    private RefreshAdvancedQueries: Subscription;
    private CallFromSocketForGyanStatus: Subscription;

    isMobile: boolean = false;
    loaderMessage = 'Fetching Article Details';
    gyanTypeGyan = false;
    displayFailmessage = false;

    constructor(
        private sanitizer: DomSanitizer,
        private commonServiceService: CommonServiceService,
        private el: ElementRef,
        private localstorage: LocalStorageService,
        //      private messageService: MessageService,
    ) {
        this.checkWidth();
        //callling subject to open article Long Story
        this.articleLongStoryDataActual = this.commonServiceService.articleLongStoryDataActual.subscribe((data: any) => {
            console.log('articleLongSotryActualData', data);
            if (data?.longStoryData) {
                this.gyanTypeGyan = false;
                this.loaderMessage = 'Fetching Article Details';
                this.displayFailmessage = false;
                //    console.log(Object.keys(data.longStoryData).length);
                if (Object.keys(data.longStoryData).length === 0) {
                    this.loading = true;
                } else {
                    this.loading = false;
                    console.log(data.longStoryData);
                    this.longStoryData = data.longStoryData;
                }
                //    console.log(this.loading);
            }

            if (data?.articleRecordId) {
                this.paraClickId = data.articleRecordId;
                setTimeout(() => {
                    this.scrollToDiv();
                }, 600);
            }
        });

        this.RefreshAdvancedQueries = this.commonServiceService.RefreshAdvancedQueries$.subscribe((value) => {
            if (value) {
                const gyanData = this.localstorage.getItem('gyanData');
                this.loading = true;
                if (gyanData.gyanStatus != 'FINISHED' || gyanData.gyanStatus != 'FAIL' || gyanData.gyanStatus != 'NO_ARTICLE_IN_SEARCH') {
                    this.displayFailmessage = false;
                    // this.loaderMessage = 'Gyan is discovering and processing content based on your selections, including current content from the internet. This may take a few minutes.'
                    this.loaderMessage =
                        'Gyan analysis from your Primary Knowledge Store will be ready momentarily.  Discovery and analysis from other sources may take a few minutes.';
                } else {
                    this.displayFailmessage = false;
                    this.loaderMessage = 'Fetching Article Details';
                }
                this.gyanTypeGyan = true;
            }
        });

        this.CallFromSocketForGyanStatus = this.commonServiceService.CallFromSocketForGyanStatus$.subscribe((value) => {
            if (value) {
                if (value.data.gyanStatus == 'FAIL' || value.data.gyanStatus == 'NO_ARTICLE_IN_SEARCH') {
                    this.loading = true;
                    this.displayFailmessage = true;
                    this.loaderMessage = 'No Article details found';
                }
                const gyanDetails = this.localstorage.getItem('gyanData');
                // const gyanData = {
                //     gyanName: gyanDetails.gyanName,
                //     gyanId: gyanDetails.gyanId,
                //     gyanType: gyanDetails.gyanType,
                //     gyanCreatedNow: gyanDetails.gyanCreatedNow,
                //     gyanStatus: value.data.gyanStatus,
                // };
                // this.localstorage.setItem('gyanData', gyanData);
                if (value?.id === gyanDetails.gyanId) {
                    const gyanData = {
                        gyanName: gyanDetails.gyanName,
                        gyanId: gyanDetails.gyanId,
                        gyanType: gyanDetails.gyanType,
                        gyanCreatedNow: gyanDetails.gyanCreatedNow,
                        gyanStatus: value.data.gyanStatus,
                    };
                    this.localstorage.setItem('gyanData', gyanData);
                } else {
                    this.localstorage.setItem('gyanData', gyanDetails);
                }
            }
        });
        // this.messageService.closeWebSocketConnection();
        // console.log('Connection closed manually.');
    }

    getSafeHtml(htmlContent: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
    }
    scrollToDiv() {
        //const containerElem = this.el.nativeElement.querySelector('#longStoryContentContainer');
        // console.log(containerElem);
        if (this.paraClickId) {
            //this.elem = document.getElementById(this.paraClickId).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            const selector = `[ids="${this.paraClickId}"]`;
            const elem = document.querySelector(selector);
            if (elem) {
                this.elem = elem;
                //       console.log('Element found:', this.elem);
                this.elem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                //       console.log('scrollIntoView called');
            } else {
                console.error(`Element with id ${this.paraClickId} not found.`);
            }
        }
    }

    checkWidth() {
        const width = window.innerWidth;
        //    console.log(width);
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }

    ngOnDestroy() {
        this.articleLongStoryDataActual.unsubscribe();
    }
}
